import { useCallback } from 'react';
import { useFlags, useFlagsmith } from 'flagsmith/react';

import { FEATURE_FLAGS, FeatureFlag } from 'app/api/services/site-configs/types';

import { useLocalFeatureFlags } from 'app/lib/feature-flags/useLocalFeatureFlags';

export const useFeatureFlags = () => {
  const {
    hasFeatureFlag: hasLocalFeatureFlag,
  } = useLocalFeatureFlags();

  const flagsmithFeatureFlag = useFlags(FEATURE_FLAGS);

  const { hasFeature } = useFlagsmith();

  const hasFeatureFlag = useCallback((featureFlag: FeatureFlag) => {
    return hasLocalFeatureFlag(featureFlag) || hasFeature(featureFlag);
  }, [flagsmithFeatureFlag]);

  return { hasFeatureFlag };
};
